import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { prepareFileName } from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { RequestTools } from '@service/request.tools';
import { formatRequestVersion } from './../displayresult/displayresult.tools';
import { Current } from '../_const/const';
import { FileUpload } from 'primeng/fileupload';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'versiondoc',
    templateUrl: 'versiondoc.component.html',
    styleUrls: ['versiondoc.component.scss'],
})
export class VersionDocComponent implements OnInit, OnChanges {
    @Input() public docId;
    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    public fr: any;
    public error = false;
    public errorMessage = '';
    public selectedVersionOri: string = 'origed';
    public versionList: any[];
    public selectedVersion: any;
    public loaded = false;
    public versionListDisabled = false;
    public versionFileDisabled = true;
    public uploadedFiles: any[] = [];
    public browseLabel = '';

    constructor(
        private requestTools: RequestTools,
        protected _messageService: MessagesService,
        private translate: TranslateService
    ) {
        this.versionList = new Array();
        this.visible = false;
        this.browseLabel = this.translate.instant('File_Sel_1');
    }

    public ngOnInit() {
        this.init();
        if (this.loaded === false) {
            this.getVersionList(this.docId);
        }
    }

    public ngOnChanges() {}

    public onClickOri() {
        this.versionListDisabled = false;
        this.versionFileDisabled = true;
    }

    public onClickFile() {
        this.versionListDisabled = true;
        this.versionFileDisabled = false;
    }

    public removeItem(file: File, uploader: FileUpload) {
        const index = uploader.files.indexOf(file);
        uploader.remove(null, index);
    }

    public onProgress($event, uploader: FileUpload) {}

    public onBeforeUpload($event, uploader: FileUpload) {
        let wRequest: string;
        let wjson = '';
        wRequest = this.addDataToFile(uploader.files[0], this.docId);
        wjson = JSON.stringify(wRequest);
        $event.formData.append('Request', wjson);
    }

    public onClickValid(aUploader: FileUpload) {
        if (this.selectedVersionOri === 'origed') {
            if (!this.verifySelect()) {
                return;
            }
            this.execVersion(this.docId, this.selectedVersion.value);
        } else {
            if (!this.verifySelectFile(aUploader)) {
                return;
            }
            this.execVersionFromFile(aUploader);
        }
    }

    private async execVersion(aDocId, aNumVersion) {
        let wRes: any;
        let wAction: {};
        if (aNumVersion === Current) {
            wAction = {
                Create: 'current',
                FileName: '',
            };
        } else {
            wAction = {
                SetVer: aNumVersion,
            };
        }
        const wParams = formatRequestVersion(aDocId, wAction);
        wRes = await this.requestTools.execUrlAction('setversion', wParams);        
        this.verifyResult(wRes);
    }

    private execVersionFromFile(aUploader) {
        aUploader.url = this.requestTools.setFile('setversionnewfile');
        aUploader.upload();
    }

    public onUpload($event) {
        for (let file of $event.files) {
            this.uploadedFiles.push(file);
        }
        if ($event.originalEvent.body) {
            this.verifyResult($event.originalEvent.body);
        } else {
            this.verifyResult({ status: false });
        }
    }

    public onError($event) {
        console.log('onError', $event);
        this.verifyResult({ status: false });
    }

    private addDataToFile(aFile, aDocId) {
        let wRequest: string;
        let wFileName: string;
        let wAction: {};
        wFileName = prepareFileName(aFile.name, 64, true);
        wAction = {
            Create: '',
            FileName: wFileName,
        };
        wRequest = formatRequestVersion(aDocId, wAction);
        return wRequest;
    }

    private verifyResult(aResult) {
        if (aResult.Status !== undefined) {
            if (aResult.Status === 'OK') {
                aResult.status = true;
            } else {
                aResult.status = false;
            }
        }
        if (aResult.status === true) {
            this._messageService.addSuccess(this.translate.instant('Vers_OK'));
            this.close('add');
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Vers_KO'));
        }
    }

    private verifySelect() {
        if (this.selectedVersion === undefined) {
            this._messageService.addErrorNoStick(this.translate.instant('Vers_Sel'));
            return false;
        } else {
            return true;
        }
    }

    private verifySelectFile(aUploader) {
        if (aUploader.files.length === 0) {
            this._messageService.addWarnNoStick(this.translate.instant('File_Sel'));
            return false;
        } else {
            return true;
        }
    }

    private async getVersionList(aDocId) {
        let wRes: any;
        let wData: any;
        this.versionList = [];

        wRes = false;
        this.requestTools.setCurrentDocId(aDocId);
        wRes = await this.requestTools.getVersionListSync();

        if (wRes.status === true) {
            wData = new Object();
            wData.name = this.translate.instant('Ver_Cur');
            wData.value = Current;
            this.versionList.push(wData);
            wRes.data.VersionList.Version.map((item) => {
                wData = new Object();
                wData.name = item.name.substring(5, 9);
                wData.value = item.value;
                this.versionList.push(wData);
            });
            this.visible = true;
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
        this.loaded = true;
    }

    public close(event) {
        this.visible = false;
        this.onClose.emit(event);
    }

    private init() {}
}
